import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/components/GlobalVideoModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/components/Layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/components/Layout/TopNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoModalProvider"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/components/VideoModalProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src686654366/src/EDGAR_MARCANO/msintapujo/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
